import { render, staticRenderFns } from "./workbooks.vue?vue&type=template&id=f70d7dda"
import script from "./workbooks.vue?vue&type=script&lang=js"
export * from "./workbooks.vue?vue&type=script&lang=js"
import style0 from "./workbooks.vue?vue&type=style&index=0&id=f70d7dda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports